// START Deprecated
document.querySelectorAll('select[name="numUnits"]').forEach(function (element) {
	element.value = element.dataset.numDisplayed;
	newElement = document.createElement("div");
	newElement.classList.add("sezzle-widget");
	newElement.classList.add("d-none");
	newElement.innerHTML = element.options[element.selectedIndex].dataset.price;
	element.form.insertBefore(newElement, element.parentNode.nextSibling);
//	element.addEventListener("change", function (event) {
//		newElement.innerHTML = element.options[element.selectedIndex].dataset.price;
//	});
});
// END Deprecated

if (document.getElementsByName("strength").length > 1) {
	document.getElementById("picker-strength").classList.remove("d-none");
	[].forEach.call(document.getElementsByClassName("drug-listing"), function (element) {
		element.classList.add("d-none");
	});
}

[].forEach.call(document.getElementsByClassName("picker-quantity"), function (element) {
	element.classList.remove("d-none");
});

[].forEach.call(document.getElementsByClassName("drug-listing-price"), function (element) {
	if (element.dataset.numUnits == element.closest(".drug-listing-prices").dataset.defaultNumUnits)
		return;
	element.classList.add("d-none");
});

[].forEach.call(document.getElementsByClassName("drug-listing-price-amount"), function (element) {
	element.classList.add("d-none");
});

[].forEach.call(document.querySelectorAll(".picker-quantity .dropdown-item"), function (element) {
	element.addEventListener("click", function (event) {
		element.closest(".drug-listing-price").classList.add("d-none");
		element.closest(".drug-listing-prices").querySelector('.drug-listing-price[data-num-units="' + event.target.value + '"]').classList.remove("d-none");
	});
});

[].forEach.call(document.getElementsByName("strength"), function (element) {
	element.addEventListener("click", function (event) {
		[].forEach.call(document.getElementsByClassName("drug-listing"), function (element) {
			element.classList.add("d-none");
		});
		[].forEach.call(document.querySelectorAll('.drug-listing[data-strength="' + event.target.value + '"]'), function (element) {
			element.classList.remove("d-none");
		});
		document.getElementById("drug-listings").scrollIntoView();
	});
});
